import { Routes } from '@angular/router';
import { AuthGuard } from './core/guards/auth.guard';
import { EmpresaGuard } from './core/guards/empresa.guard';

export const routes: Routes = [
  { path: 'login', loadComponent: () => import('./features/login/login.component').then(m => m.LoginComponent) },
  {
    path: '',
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: 'seleccion-cuenta',
        pathMatch: 'full'
      },
      {
        path: 'seleccion-cuenta',
        loadComponent: () => import('./features/seleccion-cuenta/seleccion-cuenta.component').then(m => m.SeleccionCuentaComponent)
      },
      {
        path: 'aplicaciones/:numeroCuenta',
        loadComponent: () => import('./features/aplicaciones/aplicaciones.component').then(m => m.AplicacionesComponent)
      },
      {
        path: 'aplicaciones/:numeroCuenta/:nif/:nombresCuenta/:apellidosCuenta/:email/:numeroCuentaEmpresa',
        loadComponent: () => import('./features/aplicaciones/aplicaciones.component').then(m => m.AplicacionesComponent)
      },
    ]
  },
  { path: '**', redirectTo: 'login' }
];
